import { render } from "./Wardan.vue?vue&type=template&id=b3a73864"
import script from "./Wardan.vue?vue&type=script&lang=ts"
export * from "./Wardan.vue?vue&type=script&lang=ts"

import "./Wardan.vue?vue&type=style&index=0&id=b3a73864&lang=css"
script.render = render

export default script